import amountFormatter from './amount-formatter.filter';
import msfpDateFormatter from './msfpDateFormatter.filter';

export const appFilters = {
  amountFormatter,
  msfpDateFormatter,
};

export default appFilters;
